// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const koffing: PokeData = {
  "id": 109,
  "name": "koffing",
  "height": 6,
  "weight": 10,
  "base_experience": 68,
  "types": [
    PokeType.POISON
  ],
  "api_moves": [
    "tackle",
    "toxic",
    "smokescreen",
    "haze",
    "self-destruct",
    "smog",
    "sludge",
    "poison-gas",
    "explosion",
    "sludge-bomb",
    "destiny-bond",
    "memento",
    "gyro-ball",
    "assurance",
    "clear-smog",
    "belch"
  ],
  "moves": [
    "tackle",
    "poison-gas",
    "sludge-bomb",
    "stun-spore",
    "acid-rain",
    "poison-jab",
    "poison-powder",
    "mortal-gas",
    "venom-drench",
    "toxic-spikes",
    "acid",
    "poison-fang",
    "toxic-overload"
  ],
  "evolution_chain": {
    "id": 49,
    "item": null,
    "species": [
      {
        "name": "koffing",
        "order": 121,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "weezing",
        "order": 122,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": 109,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "weezing-galar",
        "order": 122,
        "types": [
          PokeType.POISON,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 109,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 35,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 55,
    "speed": 35,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 190,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
